module.exports = __webpack_public_path__ + "static/media/datetime.353151da.gif";